export { default } from './Spicy';
